// 葡萄牙语
const pt = {
  common: {
    notSupport: 'O seu navegador não suporta o modo de ecrã inteiro',
    loadFail: 'O carregamento do tema falhou',
    noPermission: 'Desculpe, não tem permissão para aceder a essa página',
    backHome: 'Voltar à pagina principal',
    noExit: 'A página que está a tentar aceder não existe',
    serverError: 'Desculpe, o servidor encontrou um erro',
    slide: 'Deslizar para a direita',
    veryHigh: 'Muito Elevado',
    high: 'Elevado',
    target: 'Alvo',
    urgentLow: 'Muito Baixo',
    agpNoData:
      'O Relatório MPG requer pelo menos 5 dias de dados para ser gerado',
    noDataStr: 'Sem dados',
    setting: 'Configurações',
    // setting: 'Definição / Configuração?',
    personInfo: 'Informação Básica',
    updatePwd: 'Mudar Palavra-Passe',
    upHead: 'Carregar Fotografias',
    inRange: 'No Alvo',
    normal: 'Normal',
    low: 'Baixo',
    previous: 'Anterior',
    next: 'Seguinte',
    search: 'Procurar',
    reset: 'Reiniciar',
    cancel: 'Cancelar',
    ok: 'Ok',
    confirm: 'Confirmar',
    save: 'Salvar',
    submit: 'Submeter',
    successful: 'Bem Sucedido',
    pleaseEnter: 'Por favor, insira / digite',
    pleaseSelect: 'Por favor, selecione',
    success: 'Sucesso',
    confirmLogout: 'Tem certeza que quer sair?',
    updateSuccessed: 'Atualização bem sucedida',
    warning: 'Aviso',
    date: 'Data',
    start: 'Iniciar I Inicio',
    end: 'Fim',
    sevenDays: '7 Dias',
    fourteenDays: '14 Dias',
    thirtyDays: '30 Dias',
    signOut: 'Sair',
    personalInformation: 'Informação Pessoal',
    email: 'E-mail',
    name: 'Nome',
    mobile: 'Telemóvel',
    dateOfBirth: 'D.D.N',
    gender: 'Género',
    diabeteType: 'Tipo de Diabetes',
    dateOfDignose: 'Ano de Diagnóstico',
    remarks: 'Observações',
    optionMale: 'Macho',
    optionFemale: 'Fêmea',
    optionUnknow: 'Prefira não declarar',
    noDiabetes: 'Sem Diabetes',
    diabeteTypeI: 'Tipo I',
    diabeteTypeII: 'TipoII',
    diabeteSpecial: 'Especial',
    diabeteGestational: 'Diabetes Gestacional',
    diabeteOthers: 'Outros',
    ruleMsgEmail: 'Por favor, insira e-mail',
    ruleMsgName: 'Por favor, insira nome',
    ruleMsgMobile: 'Por favor, insira Telemóvel',
    ruleMsgBirthday: 'Por favor, selecione data de nascimento',
    ruleMsgSex: 'Por favor, selecione género',
    ruleMsgDiabeteType: 'Por favor, selecione Tipo de diabetes',
    ruleMsgDateOfDignose: 'Por favor, selecione, ano de diagnóstico',
    ruleMsgRemarks: 'Por favor, insira observações',
    ruleMsgCorrectMobile: 'Por favor, insira o telemóvel correto',
    oldPassword: 'Palavra-Passe Antiga',
    newPassword: 'Nova Palavra-Passe',
    confirmPassword: 'Confirme Palavra-Passe',
    ruleMsgOldPassword: 'Por favor, insira a palavra-passe antiga',
    ruleMsgNewPassword: 'Por favor, insira a nova palavra-passe',
    ruleMsgConfirmPassword: 'Por favor, confirme a palavra-passe',
    passwordInconsistent: 'As duas palavras-passe inseridas são inconsistentes',
    passwordModifySuccessed:
      'A sua palavra-passe foi redefinida, por favor, entre novamente!',
    monday: 'Seg',
    tuesday: 'Ter',
    wednesday: 'Qua',
    thursday: 'Qui',
    friday: 'Sex',
    saturday: 'Sáb',
    sunday: 'Dom',
    sn: 'NS',
    startDate: 'Data de Início',
    days: 'dias',
    pdfDate: 'Objetivo',
    close: 'fechar',
    inputTip: 'Por favor, insira palavras-chave para pesquisar',
    polarization: 'Inicialização do dispositivo',
    hour: 'h',
    minutes: 'min',
    seconds: 's',
    reportDownLoadTip: 'O seu relatório não foi gerado por 5 dias.',
    age: 'idade',
    goal: 'objetivo',
    expired: 'sensor expirado',
    lastTime: 'Hora da última atualização',
    timeZone: 'Fuso horário'
  },
  route: {
    login: 'Conecte-se',
    forget: 'Esquecer palavra-passe',
    home: 'Início',
    glucoseReport: 'Relatório da Glicose',
    sessionReport: 'Relatório da Sessão',
    eventList: 'Lista de Eventos',
    followerList: 'Lista de Seguidores',
    followerListQ: 'Solicitação de observador',
    settings: 'Configurações',
    profile: 'Perfil'
  },
  login: {
    rememberMe: 'Lembrar-me',
    forgetPassword: 'Esquecer palavra-passe',
    agree: 'Conectar-se significa concordar com FurCarer',
    privacyPolicy: 'Política de Privacidade',
    CGMUser: 'Utilizador da MCG',
    follower: 'Seguidor',
    ruleMsgPassword: 'Por favor, insira palavra-passe',
    login: 'Conectar',
    phonePlacehold: 'Por favor, insira número de telefone',
    codePlacehold: 'Por favor, insira código de verificação',
    codePlaceholdInput: 'Por favor, insira t...',
    phoneTip: 'Por telefone',
    emialTip: 'Por E-mail',
    codeTip: 'Obter código de verificação',
    reGetTip: 'Reaquisição'
  },
  layout: {
    collapseUp: 'Ocultar o menu',
    collapseDown: 'Expandir o Menu',
    refresh: 'Atualizar',
    backHome: 'Início',
    helpCenter: 'Centro de Ajuda',
    fullScreen: 'Ecrã inteiro'
  },
  forget: {
    ruleMsgCode: 'Por favor, insira código',
    sendCode: 'Enviar código',
    tipsMsgSendSuccess: 'O código de verificação foi enviado com sucesso!',
    tipsMsgModifySuccess: 'Alteração da palavra-passe bem sucedida'
  },
  home: {
    title: 'FurCarer Portal',
    todaysGlucose: 'Glicose Hoje',
    todaysOverview: 'Vista geral hoje',
    maxGlucose: 'Glicose Max.',
    minGlucose: 'Glicose Min.',
    avgGlucose: 'Glicose Méd.',
    maxmumVariation: 'Variação Máxima',
    glucose: 'Glicose',
    tir: 'TNI',
    latestGlucose: 'Última Glicose',
    todayPercentage: '% de hoje em diferentes intervalos',
    fourHour: '4 Horas',
    eightHour: '8 Horas',
    twelveHour: '12 Horas',
    twentyFourHour: '24 Horas',
    glucoseOnly: 'Apenas Glicose',
    sessionOverview: 'Vista Geral da Sessão',
    glocuseMetrics: 'Métricas da Glicose',
    agp: 'AGP',
    dailyGlucose: 'Glicose Diária',
    sessionGlucose: 'Sessão da Glicose',
    standTir: 'TNI Padrão',
    customTir: 'TNI Personalizado',
    cancleGz: 'Deixar de seguir',
    cancleText: 'Deseja deixar de seguir o Utilizador atual?',
    helpCenterTip: 'Função ainda não aberta'
  },
  glucoseReport: {
    statics: 'Estatística',
    sixHour: '6 Horas TNI',
    avgGlucose: 'Glicose Média',
    maxGlucose: 'Glicose Max',
    minGlucose: 'Glicose Min',
    cv: 'CV',
    high: 'Números de Altas',
    low: 'Números de Baixas',
    normal: 'Números de Normais',
    tir: 'TNI',
    estimatedA1c: 'A1c Estimada',
    min: 'Min',
    avg: 'Méd',
    max: 'Máx',
    maxVariation: 'Variação Máx'
  },
  glucoseProfile: {
    avg: 'Méd',
    sd: 'DP',
    cv: 'CV'
  },
  eventList: {
    all: 'Todos',
    bg: 'BG',
    meal: 'Refeição',
    sport: 'Desportos',
    insulin: 'Insulina',
    alert: 'Alerta',
    eventType: 'Tipo de Evento',
    description: 'Descrição',
    note: 'Nota',
    highAlert: 'Aviso de alerta',
    calibration: 'Calibração',
    meds: 'Medicamentos',
    time: 'Hora',
    detail: 'Detalhe',
    weigt: 'Peso'
  },
  followerList: {
    title: 'Utilizadores de Monitorização',
    tabTitle: 'Gestão de Seguidores',
    refreshText:
      'Atualização automática (a lista de utilizadores atualiza automaticamente a cada 30 segundos)',
    addText: 'Adicionar',
    dataText: 'Dados obtidos',
    timeText: 'minutos',
    hourText: 'horas',
    agoText: 'atrás',
    tableEmail: 'insira número de conta',
    searchPlacehold: 'Por favor, insira o seu número de conta para procurar',
    pending: 'Pendente',
    approved: 'Aprovado',
    rejected: 'Rejeitado',
    addFollower: 'Adicionar Seguidor',
    editFollower: 'Editar Seguidor',
    tableName: 'Nome',
    tableAddTime: 'Adicionar Hora',
    tableStatus: 'Estado',
    tableApproved: 'Aprovado',
    tableReject: 'Rejeitar',
    tableStartSharing: 'Iniciar Partilha',
    tableStopSharing: 'Parar de Compartilhar',
    op: 'Operação',
    sharing: 'Partilhar',
    notSharing: 'Não Partilhar',
    tableRemove: 'remover',
    note: 'Nota',
    message: 'Mensagem',
    ruleMsgEmailEmpty: 'Por favor, insira e-mail para procurar',
    ruleMsgNote: 'Por fvaor, intoduza nota',
    ruleMsgMessage: 'Por favor, deixe mensagem',
    ruleMsgEmailCorrect: 'Por favor, insira o e-mail correto',
    formAcknowledge:
      'Reconheço que adicionar o seguidor permitirá que este utilizador veja os meus dados',
    sendFollowRequest: 'Enviar solicitação de acompanhamento',
    setNote: 'Definir nota',
    tipsAcknowledge:
      'Verifique a caixa, você reconhece que adicionar o seguidor permitirá que este utilizador veja os meus dados',
    stopSharing: 'Parar de Compartilhar',
    startSharing: 'Iniciar partilha',
    removeUser: 'Remover Utilizador',
    confirmStopSharing:
      'Tem certeza que quer parar de partilhar as glicoses com este utilizador?',
    confirmStartSharing:
      'Tem certeza que quer começar a partilhar as glicoses com este utilizador?',
    confirmRemove: 'Tem certeza que quer remover este utilizador da lista?',
    approvedFollower: 'Seguidor Aprovado',
    rejectFollower: 'Rejeitar Seguidor',
    confirmApproved: 'Tem certeza que quer aprovar o pedido deste seguidor?',
    confirmReject: 'Tem certeza que quer rejeitar o pedido deste utilizador?',
    addTime: 'Adicionar Hora',
    check: 'Verificar',
    remove: 'Remover',
    removeUserTitle: 'Tem certeza que quer remover este utilizador da lista?'
  },
  settings: {
    title: 'Configuração dos Níveis de Glicose',
    unitSet: 'Configuração da unidade',
    targetSet: 'Configuração do TNI Personalizado',
    alertSet: 'Configuração de alerta',
    highAlert: 'Alerta de Altas',
    lowAlert: 'Alerta de Baixas',
    urgentLow: 'Baixa urgente',
    urgentHigh: 'Alta urgente',
    target: 'Alvo'
  },
  pdf: {
    dailyStatistics: 'Estatísticas Diárias',
    title: 'Relatório AGP',
    page: 'Página',
    generated: 'Gerado',
    lage: 'LAGE',
    mage: 'MAGE',
    modd: 'MODD',
    range: 'Tempo no Intervalo-Alvo',
    timeInRange: 'Tempo no Intervalo-Alvo (TNI)',
    agpTitle: 'Perfil de Glicose Ambulatória (AGP)',
    agpSubTitle:
      'AGP é um resumo dos valores de glicose do período do relatório, com mediana (50%) e outros percentis mostrados como se tivessem ocorrido num único dia',
    dailyTitle: 'Perfil Glicose Diária',
    dailySubTitle:
      'Cada perfil diário representa um período da meia-noite à meia-noite.',
    device: 'Dispositivo',
    tDevice: 'Dispositivo Terminal',
    print: 'Imprimir',
    model: 'Modelo',
    deviceSn: 'NS Dispositivo',
    effectiveData: 'Dados Válidos',
    days: 'Dias',
    appVer: 'Versão da App',
    smartPhoneModel: 'Modelo do Telemóvel',
    osVersion: 'Versão OS',
    appSetting: 'Configuração da App',
    GoalsforType1andType2Diabetes: 'Objetivos para diabetes tipo 1 e tipo 2',
    Each1timeinrange15minutes: 'Cada 1% tempo no intervalo = ~ 15 minutos',
    note: 'Nota: A unidade % aplica-se ao padrão DCCT, enquanto a unidade mmol/mol aplica-se ao padrão IFCC.',
    DOB: 'D.D.N',
    SN: 'NS'
  },
  field: {
    timeCgmActive: 'Time MCG ativo',
    gmi: 'IGG',
    gri: 'IRG',
    eHbA1c: 'eHbA1c',
    avgPerDay: 'Méd. Calibração por dia',
    glucoseAbility: 'Variabilidade Glicemica',
    lage: 'Lage',
    mage: 'Mage',
    tar: 'TAcI',
    tbr: 'TAbI',
    calibrations: 'Tempos de calibração'
  },
  agp: {
    agpTitle: 'Perfil de Glicose Ambulatória（AGP）',
    centerLine: 'Mediana',
    areaLine: 'Intervalo',
    target: 'Intervalo Alvo'
  },
  basic: {
    customTir: 'TNI Personalizado',
    bloodTip: 'Configurações de lembretes de glicose',
    bloodUnit: 'Unidade de Glicose',
    highTip: 'Alerta de Glicose Alta',
    lowTip: 'Alerta de Glicose Baixa',
    unitText: 'Definido automaticamente com base na região do país',
    selectTip:
      'Clique no ícone para selecionar ou desselecionar a data correspondente',
    selectAll: 'Selecionar Tudo'
  },
  report: {
    threeMonth: 'Últimos 3 meses',
    sixMonth: 'Quase 6 meses',
    yearText: 'Ano anterior',
    showAll: 'Mostrar tudo',
    all: 'Tudo',
    selectDate: 'Selecionar o intervalo de data',
    to: 'para',
    startDt: 'Data de Início',
    endDt: 'Data de Fim',
    betaTest: 'Teste Beta',
    bloodData: 'Dados glicose',
    userCount: 'Count User'
  },
  petDetail: {
    variety: 'Raça',
    type: 'Tipo de Insulina',
    freq: 'Freq. Insulina',
    lente: 'Lente',
    insulin: 'Insulina Glargina',
    pzi: 'PZI',
    nph: 'NPH',
    detemir: 'Detemir'
  },
  pdfReport: {
    title: 'Relatório AGP',
    snNumber: 'NS',
    page: 'Página',
    createTime: 'Gerado',
    petInfo: 'Informação do Animal de Estimação',
    petName: 'Nome do Animal de Estimação',
    birthday: 'D.D.N',
    freq: 'Freq. Insulina',
    petType: 'Tipo de Animal de Estimação',
    age: 'Idade',
    registerType: 'Tipo de Seringa',
    basicBloodData: 'Métrica da Glicose',
    dbText: 'Tempo no Intervalo-Alvo (TNI)',
    target: 'Objetivos para diabetes tipo 1 e tipo 2',
    recordTime: 'Tempo da Gravação',
    tag: 'etiqueta',
    event: 'Evento',
    eventDetail: 'Detalhes do Evento',
    mulityText: 'Gráfico de tendência da glicose de vários dias',
    mulitySubText:
      'Os perfis de glicose de vários dias representam o intervalo de tempo de um conjunto de dispositivos',
    avageBlood: 'Glicose Média',
    bloodText: 'MODD',
    highTip: 'Alerta de Glicose Alta',
    lowTip: 'Alerta de Glicose Baixa',
    cat: 'Gato',
    dog: 'Cão',
    country: 'País',
    insulinDose: 'Dose de Insulina',
    weightUnit: 'Kg'
  },
  eventDetail: {
    Empty: 'Vazia',
    Breakfast: 'Pequeno de Almoço',
    Lunch: 'Almoço',
    Dinner: 'Jantar',
    Before_Sleep: 'Antes de Deitar',
    Extra: 'Extra',
    Short_acting: 'Ação curta',
    Pre_mixed: 'Pré-mistura',
    Long_acting: 'Ação longa',
    Middle_acting: 'Ação intermédia',
    hour: 'h',
    minutes: 'min',
    After_Breakfast: 'Depois do Pequeno Almoço',
    Before_Lunch: 'Antes de Almoço'
  }
};
export default pt;
